/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useForm,
  FieldValues,
  SubmitHandler,
  Controller
} from 'react-hook-form';
import { Form, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';
import inventoryItemService from 'service/inventoryItem';
import { showAlert } from 'store/alert/alert.thunk';

interface UpdateQuantityProps {
  setOpenAmount: (show: boolean) => void;
  selectedQuantity?: any;
  refetchInventoryItem?: any;
}

const UpdateQuantity = ({
  setOpenAmount,
  selectedQuantity,
  refetchInventoryItem
}: UpdateQuantityProps) => {
  const { t } = useTranslation();

  const { register, handleSubmit, control } = useForm();
  const dispatch: Dispatch<any> = useDispatch();
  const inputRef = useRef<HTMLInputElement | any>();
  const [updatedQuantityActualValue, setUpdatedQuantityActualValue] =
    useState('');

  const onSubmit: SubmitHandler<FieldValues> = () => {
    const quantityStrCurrentBalance = String(selectedQuantity?.quantity);
    let integerPartCurrentBalance = 0;
    let numeratorCurrentBalance = 0;
    let denominatorCurrentBalance = 0; // Default denominator to 1

    if (quantityStrCurrentBalance.includes('/')) {
      [numeratorCurrentBalance, denominatorCurrentBalance] =
        quantityStrCurrentBalance.split('/').map(Number);
      integerPartCurrentBalance = numeratorCurrentBalance;
    } else {
      integerPartCurrentBalance = +quantityStrCurrentBalance;
    }

    const packageQuantity = +selectedQuantity?.package_quantity || 1;

    const adjustedQuantityCurrentBalance =
      selectedQuantity?.measure_unit_kind_id ===
      '3c7cee55-ad41-4ee3-a409-a7bb5f428b36'
        ? integerPartCurrentBalance * packageQuantity +
          denominatorCurrentBalance
        : integerPartCurrentBalance;

    const quantityStr = String(updatedQuantityActualValue);
    let integerPart = 0;
    let numerator = 0;
    let denominator = 0; // Default denominator to 1

    if (quantityStr.includes('/')) {
      [numerator, denominator] = quantityStr.split('/').map(Number);
      integerPart = numerator;
    } else {
      integerPart = +quantityStr;
    }

    const adjustedQuantity =
      selectedQuantity?.measure_unit_kind_id ===
      '3c7cee55-ad41-4ee3-a409-a7bb5f428b36'
        ? integerPart * packageQuantity + denominator
        : integerPart;

    const newQuantity =
      selectedQuantity?.measure_unit_kind_id ===
      '3c7cee55-ad41-4ee3-a409-a7bb5f428b36'
        ? +adjustedQuantityCurrentBalance + +adjustedQuantity
        : +selectedQuantity?.quantity + +adjustedQuantity;

    if (newQuantity < 0) {
      dispatch(
        showAlert({
          title: t('quantity_must_not_less_zero')
        })
      );
    }
    if (
      updatedQuantityActualValue !== '' &&
      selectedQuantity.quantity !== '' &&
      newQuantity >= 0
    ) {
      inventoryItemService
        .updateInventoryItem(selectedQuantity?.pid, {
          quantity_actual: newQuantity
        })
        .then(res => {
          if (res) {
            dispatch(
              showAlert({
                title: `${t('quantity')} ${t('successfully_added')}`,
                type: 'success'
              })
            );
            setOpenAmount(false);
            refetchInventoryItem();
          }
        });
    }
  };

  const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    // Allow numbers, decimals, commas, and fractions
    if (/^-?[\d.,/]*$/.test(newValue)) {
      setUpdatedQuantityActualValue(newValue);
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);
  return (
    <>
      <Form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <Row className="mb-3">
          <Col>
            <Form.Floating className="md-4">
              <Form.Control
                disabled
                defaultValue={selectedQuantity?.quantity}
                {...register('amount')}
                type="text"
                placeholder={t('current_quantity')}
                onFocus={e => e.target.select()}
              />
              <label htmlFor="floatingInputCustom">
                {t('current_quantity')}
              </label>
            </Form.Floating>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Controller
              name="quantity_actual"
              control={control}
              render={({ field }) => (
                <Form.Floating className="md-4">
                  <Form.Control
                    {...field}
                    ref={inputRef}
                    type="text"
                    value={updatedQuantityActualValue}
                    onChange={handleQuantityChange}
                    placeholder={t('new_quantity')}
                    onFocus={e => e.target.select()}
                    autoComplete="off"
                  />
                  <label htmlFor="floatingInputCustom">
                    {t('new_quantity')}
                  </label>
                </Form.Floating>
              )}
            />
          </Col>
        </Row>

        <Button
          style={{ height: '48px', marginTop: 'auto' }}
          className="w-100"
          variant="primary"
          type="submit"
        >
          {t('apply')}
        </Button>
      </Form>
    </>
  );
};

export default UpdateQuantity;
